import { thousandSeparated } from './formatting';

const resolveCurrencySuffix = (currencyCode: string | null) => {
    switch (currencyCode) {
        case 'SEK':
            return 'kr';
        case 'DKK':
            return 'kr';
        case 'ISK':
            return 'kr';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'USD':
            return '$';
        case 'CAD':
            return '$';
        case 'JPY':
            return '¥';
        default:
            return 'kr';
    }
};

export interface Money {
    currency: string;
    value: number;
}

export const requiredFields = ['currency', 'value'];

export const getDisplayCurrency = ({ currency, value }: Money): string => {
    const currencySymbol = resolveCurrencySuffix(currency);
    if (currencySymbol === 'kr') {
        return `${thousandSeparated(value)} ${currencySymbol}`;
    }
    return `${currencySymbol}${thousandSeparated(value)}`;
};

export const createMoney = (data: Record<string, unknown>): Money => {
    for (const fieldName of requiredFields) {
        if (!(Object.hasOwn(data, fieldName) && typeof data[fieldName] !== 'undefined')) {
            throw new Error(`createMoney: "${fieldName}" is required`);
        }
    }

    return {
        currency: data.currency as string,
        value: data.value as number,
    };
};
